module.exports = __webpack_public_path__ + "img/1440347695.0d5969f5.jpg";